$(document).ready(function () {
    $('.btn-mobile-menu').click(function (e) {
        e.preventDefault();
        $('.btn-mobile-menu').toggleClass('is-active');
        $('body').toggleClass('smenu');
    });

    $('.gray-overlay').click(function (e) {
        e.preventDefault();
        $('.btn-mobile-menu').toggleClass('is-active');
        $('body').toggleClass('smenu');
    });

    var items = $('.home-slider .item');

    if (items.length > 1) {
        $('.home-slider.owl-carousel').owlCarousel({
            loop: true,
            items: 1,
            autoplayHoverPause: true,
            autoplay: true,
            autoplayTimeout: 10000,
            smartSpeed: 900,
            nav: false,
            dots: true,
            onInitialized: function() {
                $('.home-slider .owl-dots').children('.owl-dot').attr('tabindex', -1);
            }
        });
    } else {
        $('.home-slider.owl-carousel').owlCarousel({
            items: 1,
            mouseDrag: false,
            touchDrag: false
        });
    }
});
